import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import ConvertUnit from "../../../../components/Math/Conversion/ConvertUnit";
import { ImperialUnits } from "../../../../components/Math/Units/AllUnits";
import Kilopound from "../../../../components/Math/Units/Imperial/Kilopound";
import KiloNewton from "../../../../components/Math/Units/Metric/KiloNewton";
import { NumberFormatText } from "../../../../components/NumberFormatText";
import { RowBody } from "../../../../components/RowValue/RowBody";
import ToolTip, { IconType } from "../../../../components/ToolTip";
import { useGetCarryingElementQuery } from "../../../../services/API/titanApi";
import {
  selectFactoredCompressionResistance,
  selectHoleSize,
  selectTwentyEightDayGroutStrength,
  selectedCarryingElement,
  setFactoredCompressionResistance,
} from "../../../../store/slices/aashtoSlice";

function berechne_fy(carryingElementData) {
  return (
    carryingElementData?.CharacteristicLoadCarryingCapacity / carryingElementData?.CrossSectArea
  );
}

function berechne_fyControlling(fy) {
  const FIX_VALUE = 87;
  return fy > FIX_VALUE ? FIX_VALUE : fy;
}
function berechne_factoredCompressionResistance(
  twentyEightDayGroutStrength,
  bitholeSize,
  fyControlling,
  CrossSectArea
) {
  return (
    0.85 *
    (0.85 *
      Number(twentyEightDayGroutStrength) *
      ((Math.PI * Math.pow(Number(bitholeSize), 2)) / 4) +
      Number(fyControlling) * Number(CrossSectArea))
  );
}
function FactoredCompressionResistance() {
  const dispatch = useDispatch();

  const FactoredCompressionResistanceFormula =
    "\\displaystyle R_n = 0.85 \\cdot \\left[ 0.85\\cdot f'_c \\cdot A_g + F_y \\cdot A_b \\right]";

  const carryingElement = useSelector(selectedCarryingElement);
  const twentyEightDayGroutStrength = useSelector(selectTwentyEightDayGroutStrength);
  const factoredCompressionResistance = useSelector(selectFactoredCompressionResistance);
  const { data: carryingElementData } = useGetCarryingElementQuery(carryingElement?.name);

  const bitholeSize = useSelector(selectHoleSize);

  // let fy =
  //   carryingElementData?.CharacteristicLoadCarryingCapacity /
  //   carryingElementData?.CrossSectArea;
  let fy = berechne_fy(carryingElementData);

  //let FIX_VALUE = 87;
  //let fyControlling = fy > FIX_VALUE ? FIX_VALUE : fy;
  let fyControlling = berechne_fyControlling(fy);

  useEffect(() => {
    // let factoredCompressionResistance =
    //   0.85 *
    //   (0.85 *
    //     Number(twentyEightDayGroutStrength.imperial) *
    //     ((Math.PI * Math.pow(Number(bitholeSize.imperial), 2)) / 4) +
    //     Number(fyControlling) * Number(carryingElementData?.CrossSectArea));
    let factoredCompressionResistance = berechne_factoredCompressionResistance(
      twentyEightDayGroutStrength.imperial,
      bitholeSize.imperial,
      fyControlling,
      carryingElementData?.CrossSectArea
    );

    dispatch(
      setFactoredCompressionResistance({
        value: factoredCompressionResistance,
        unit: ImperialUnits.Kilopound,
      })
    );
  }, [
    twentyEightDayGroutStrength.imperial,
    carryingElementData,
    carryingElement,
    bitholeSize.imperial,
    fyControlling,
  ]);

  return (
    <RowBody
      formulaValue={
        <ToolTip
          id={"FactoredCompressionResistanceFormula"}
          type={IconType.FORMULA}
          formula={FactoredCompressionResistanceFormula}
        />
      }
      indicesValue={
        <span>
          R<sub>n</sub>
        </span>
      }
      inputValue={
        <span className="input">
          <NumberFormatText value={factoredCompressionResistance.current} decimalScale={2} />
        </span>
      }
      unitValue={<ConvertUnit Metric={<KiloNewton />} Imperial={<Kilopound />} />}
    />
  );
}

export default FactoredCompressionResistance;
